import { formatMinutesToHoursAndMinutes } from '../dates';
import { DateRange } from '@ui/calendar/types';

export const calculateDuration = (date: DateRange) => {
  if (!date || date.startDate === null || date.endDate === null) {
    return '';
  }

  if (isNaN(date.startDate) || isNaN(date.endDate)) {
    return '';
  }

  let totalMinutes = 0;

  if (date.startDate && date.endDate) {
    const diff = date.endDate - date.startDate;
    totalMinutes += diff / 60000;
  }
  return formatMinutesToHoursAndMinutes(totalMinutes);
};
